<template>
	<img
		class="partner-kb-ad"
		:src="`/images/edu/partner/edu-partner-kb-floating-menu.svg` | getCdnImageSrc"
		alt=""
		@click="handleGoLiivem"
	/>
</template>

<script>
import routeMixin from '../../../../mixins/routeMixin';
import { getCdnImageSrc } from '../../../../utils/util';

export default {
	name: 'PartnerKBAd',
	mixins: [routeMixin],
	methods: {
		handleGoLiivem() {
			this.$_openURL('https://www.liivm.com');
		},
	},
	filters: {
		getCdnImageSrc,
	},
};
</script>

<style lang="scss" scoped>
.partner-kb-ad {
	cursor: pointer;
	position: fixed;
	bottom: 100px;
	right: 52px;
}
</style>
